import { Box, Switch } from "@material-ui/core"
import { queryCache, useMutation, useQuery } from "react-query"

import { ChangeEvent } from "react"
import React from "react"
import { css } from "@emotion/css"
import { fetchCurrentMarket } from "api/markets"
import { updateMarket } from "api/regions"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

export const EnablePostingToIsapToggle = () => {
  const { t } = useI18n()
  const { meta, hasAuthority } = useAuthenticated()
  const { layerId } = meta ?? {}
  const [enabled, setEnabled] = React.useState<boolean | undefined>(false)

  const { data: market } = useQuery("current-market", fetchCurrentMarket)

  const [patch] = useMutation(updateMarket, {
    onSuccess: () => {
      queryCache.invalidateQueries("current-market")
    },
  })

  const handleChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    patch({
      id: layerId,
      postingToIsapEnabled: checked,
    })
  }

  React.useEffect(() => {
    market?.postingToIsapEnabled !== enabled &&
      setEnabled(market?.postingToIsapEnabled)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [market])

  return (
    <Box className={styles.container}>
      <div className="BodyBody1Regular">
        {`${t("market.enable.postToIsap.toggle")}:`}
      </div>
      <Switch
        name={t("market.enable.postToIsap.on")}
        checked={enabled}
        onChange={handleChange}
        disabled={!hasAuthority(["AUTH_EDIT_MARKET"])}
        color={hasAuthority(["AUTH_EDIT_MARKET"]) ? "primary" : undefined}
      />
      <div className="BodyBody1Regular">{t("market.enable.postToIsap.on")}</div>
    </Box>
  )
}

const styles = {
  container: css`
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    padding: var(--spacing-xxs) 0 0;
    align-items: center;
  `,
  labelPlacementStart: css`
    margin: 0;
  `,
  label: css`
    min-width: 70px;
  `,
}
